export default "__VITE_ASSET__CfH8Xkc3__"